import styled, { ThemeProvider } from "styled-components";
import { darkTheme } from "./Utils/Themes";
import Navbar from "./components/Navbar/Navbar.jsx";
import { BrowserRouter } from "react-router-dom";
import Hero from "./components/Sections/Hero.jsx";
import Skills from "./components/Sections/Skills.jsx";
import Experience from "./components/Sections/Experience.jsx";
import Education from "./components/Sections/Education.jsx";
import Certifications from "./components/Sections/Certifications.jsx";
import StartCanvas from "./components/Canvas/Stars.jsx";
import Projects from "./components/Sections/Projects.jsx";
import Contact from "./components/Sections/Contact/Contact.jsx";
import Footer from "./components/Sections/Footer.jsx";
import { useState } from "react";
import ProgressBar from "react-scroll-progress-bar"; //Add this line to import the component
import Terminal from "./components/Splash/Terminal.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Body = styled.div`
  background-color: ${({ theme }) => theme.bg};
  width: 100%;
  overflow-x: hidden;
  position: relative;
`;

const Wrapper = styled.div`
  padding-bottom: 100px;
  background:
    linear-gradient(
      38.73deg,
      rgba(204, 0, 187, 0.15) 0%,
      rgba(201, 32, 184, 0) 50%
    ),
    linear-gradient(
      141.27deg,
      rgba(0, 70, 209, 0) 50%,
      rgba(0, 70, 209, 0.15) 100%
    );
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 30% 98%, 0 100%);
`;

function App() {
  const [isVisible, setIsVisible] = useState(true); // change to false if want to show terminal

  return (
    <>
      <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      {/*removefalse if want to show terminal*/}
      {!isVisible && false && <Terminal setIsVisible={setIsVisible} />}
      <ProgressBar height="10" bgcolor="#fff" duration="0" />
      {isVisible && (
        <ThemeProvider theme={darkTheme}>
          <BrowserRouter>
            <Navbar />
            <Body>
              <StartCanvas />
              <div>
                <Hero />
                <Wrapper>
                  <Skills />
                  <Experience />
                </Wrapper>
                <Projects />
                <Wrapper>
                  <Education />
                  <Certifications />
                  <Contact />
                </Wrapper>
                <Footer />
              </div>
            </Body>
          </BrowserRouter>
        </ThemeProvider>
      )}
    </>
  );
}

export default App;
